import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import LockIcon from '@mui/icons-material/Lock';
import Dropdown from 'react-multilevel-dropdown';
import cx from "classnames";

//Styles
import './selectorMultiLevel.scss';

const MultiLevelSelector = (props) => {
    const { options, label, position, selectedItems, noIcon } = props

    return (
        <div className="multi-level-selector">
            <Dropdown
                title={<div>{label}<ArrowDropDownIcon className="multi-level-selector-icon" /></div>}
                buttonClassName="MuiButtonBase-root MuiButton-root MuiButton-text button-dropdown"
                menuClassName="multi-level-selector-container"
                position={position}
            >
                {
                    options.map((option, index) => {
                        let enabled = true;
                        if (option.single) enabled = selectedItems.length === 1
                        if (option.multiple) enabled = selectedItems.length > 0
                        if (option.disabled) enabled = !option.disabled

                        if (option.show) {
                            return (
                                <Dropdown.Item
                                    className={cx("multi-level-selector-item", !enabled ? "multi-level-selector-item-disabled" : "")}
                                    isDisabled={!enabled}
                                    onClick={(event) => option?.action ? option.action(selectedItems, event) : {}}
                                    key={index}
                                >
                                    {option.label}
                                    {!enabled ? (
                                        <LockIcon style={{ fontSize: 12, opacity: 0.5, marginRight: 6 }} />
                                    ) : (<></>)}
                                    {
                                        option.submenu && !noIcon ? <ArrowRightIcon style={{ color: '#172B4D' }} /> : <></>
                                    }
                                    {
                                        option.submenu && !option?.disabled ? (
                                            <Dropdown.Submenu
                                                position={position}
                                                className="multi-level-selector-submenu"
                                            >
                                                {
                                                    option.submenu.map((item, index2) => {
                                                        let enabled1 = true;
                                                        if (item.single) enabled1 = selectedItems.length === 1
                                                        if (item.multiple) enabled1 = selectedItems.length > 0
                                                        if (item.disabled) enabled1 = !item.disabled

                                                        if (item.show) {
                                                            return (
                                                                <Dropdown.Item
                                                                    key={index2}
                                                                    isDisabled={!enabled1}
                                                                    onClick={(event) => item.action(selectedItems, event)}
                                                                    className={cx("multi-level-selector-item", !enabled1 ? "multi-level-selector-item-disabled" : "")}
                                                                >
                                                                    {item?.label}
                                                                    {item.disabled ? (
                                                                        <LockIcon style={{ fontSize: 12, opacity: 0.5, marginRight: 6 }} />
                                                                    ) : (<></>)}
                                                                </Dropdown.Item>
                                                            )
                                                        }
                                                    })
                                                }
                                            </Dropdown.Submenu>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Dropdown.Item>
                            )
                        }
                    })
                }
            </Dropdown>
        </div>
    )
}

export default MultiLevelSelector